import { render, staticRenderFns } from "./UnitRoomInventoryForm.vue?vue&type=template&id=8890bcb4&scoped=true&"
import script from "./UnitRoomInventoryForm.vue?vue&type=script&lang=js&"
export * from "./UnitRoomInventoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8890bcb4",
  null
  
)

export default component.exports